import { create } from "zustand";

export const useAuthStore = create((set) => ({
  error: "",
  getToken: () => localStorage.getItem("token"),
  setError: (error) => set({ error }),

  auth: () => !!localStorage.getItem("token"),

  getAuthHeaders: () => {
    const token = localStorage.getItem("token");
    const tenantId = localStorage.getItem("tenantId");
    const role = localStorage.getItem("role");
    console.log("getAuthHeaders - Token:", token, "TenantId:", tenantId, "Role:", role);

    if (!token) {
      console.error("No token found in localStorage");
      return {
        headers: {
          "Content-Type": "application/json",
          Authorization: "",
        },
        params: "",
      };
    }

    const params = new URLSearchParams();
    if (tenantId && tenantId !== "null" && role !== "SuperAdmin") {
      params.append("tenantId", tenantId);
    }
    if (role === "SuperAdmin") {
      params.append("allTenants", "true");
    }

    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    };

    console.log(
      "getAuthHeaders - Constructed headers:",
      headers,
      "Params:",
      params.toString()
    );

    return {
      headers,
      params: params.toString(),
    };
  },

  authRegister: async (authData) => {
    try {
      const url = `${process.env.REACT_APP_API_URL}api/users/register`;
      console.log("authRegister - URL:", url, "Data:", authData);

      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(authData),
      });

      if (!response.ok) {
        const errorText = await response.text();
        console.error("Register error response:", errorText);
        const errorData = JSON.parse(errorText);
        throw new Error(errorData.message || "Registration failed");
      }

      const data = await response.json();
      set({ error: "" });
      return data;
    } catch (error) {
      set({ error: error.message || "Registration failed" });
      throw error;
    }
  },

  authLogin: async (authData) => {
    try {
      const url = `${process.env.REACT_APP_API_URL}api/users/login`;
      console.log("authLogin - URL:", url, "Data:", authData);

      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(authData),
      });

      if (!response.ok) {
        const errorText = await response.text();
        console.error("Login error response:", errorText);
        const errorData = JSON.parse(errorText);
        throw new Error(errorData.message || "Login failed");
      }

      const data = await response.json();
      console.log("adminStore.js - Login response:", data);

      if (data.token) {
        localStorage.setItem("token", data.token);
        localStorage.setItem("tenantId", data.user.tenantId || null);
        localStorage.setItem("role", data.user.role);
        localStorage.setItem("email", data.user.email);
        console.log("adminStore.js - Stored in localStorage:", {
          token: data.token,
          tenantId: data.user.tenantId || null,
          role: data.user.role,
          email: data.user.email,
        });
      }

      set({ error: "" });
      console.log("adminStore.js - auth state should be true (token set)");

      return data;
    } catch (error) {
      set({ error: error.message || "Login failed" });
      throw error;
    }
  },

  logout: () => {
    localStorage.clear();
    set({ error: "" });
    console.log("adminStore.js - Logged out, auth should be false");
    window.location.href = "/";
  },
}));